import React from "react";
import ReactCodeInput from "react-verification-code-input";
import "./index.less";

interface VerificationInputCProps extends ReactCodeInput {}
const VerificationInputC = (props: any) => {
  return <ReactCodeInput className="VerificationInputC" {...props} />;
};

export default VerificationInputC;
